import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function ExternalLink(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.999 2.81a1 1 0 110 2h-8v15.998h15.998v-8a1 1 0 112 0v8.202a1.8 1.8 0 01-1.797 1.798H2.798A1.8 1.8 0 011 21.01V4.608A1.8 1.8 0 012.798 2.81h8.2zM21.983 1l.039.001.043.003L21.983 1c.054 0 .106.005.158.013l.022.004.019.003.03.007a.993.993 0 01.038.01l.049.015a.764.764 0 01.107.042c.023.01.046.023.069.035l.029.018.015.009c.13.083.24.195.32.327l.005.009.011.019a.996.996 0 01.079.18l.013.044c.007.024.013.05.018.076l.005.032a.824.824 0 01.01.078l.002.044v-.001V9.175a1 1 0 11-2 0V4.402l-8.18 8.126a1 1 0 01-1.41-1.42L19.556 3h-4.748a1 1 0 110-2h7.175z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoExternalLink = React.memo(ExternalLink);
export default MemoExternalLink;